import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./ComplaintAssignEngineer.css";
import { Col, Form, Row } from "react-bootstrap";
import ModalSave from "../../ModalSave";
import { SaveButton, CancelButton } from "../../Button";
import { getData, postData } from "../../../../utils/api";
import Select from "react-select";
import ModalComplaintSave from "../../ModalComplaintSave";

const ComplaintAssignEngineer = ({ show, onHide, getAllData, id }) => {
  const [errors, setErrors] = useState({});

  const [from, setFrom] = useState("");
  const [schedule_time, setScheduleTime] = useState("");
  const [completion_date, setCompletionDate] = useState("");
  const [engineer, setEngineer] = useState(null);
  const [serviceEngineer, setServiceEngineer] = useState([]);
  const [product, setProduct] = useState([]);
  const [productIDS, setProductIDS] = useState([]);

  const [assignLoading, setAssignLoading] = useState(false);

  const [productSelections, setProductSelections] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const validateForm = () => {
    const newErrors = {};

    if (!engineer) {
      newErrors.engineer = "Please select a service engineer";
    }

    if (!completion_date) {
      newErrors.engineer = "Please select a Completion date";
    }

    if (!schedule_time) {
      newErrors.engineer = "Please select a Schedule Time";
    }

    if (!from) {
      newErrors.from = "Please select a schedule date";
    } else {
      const selectedDate = new Date(from);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        newErrors.from = "Schedule date cannot be in the past";
      }
    }

    if (!completion_date) {
      newErrors.from = "Please select a Completion date";
    } else {
      const selectedDate = new Date(completion_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        newErrors.from = "Completion date cannot be in the past";
      }
    }

    // ✅ Product validation
    if (!productSelections || productSelections.length === 0) {
      newErrors.product = "Please select at least one product";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const GetAllServiceEngineer = async () => {
    const response = await getData("/masters/all-service-engineers");

    if (response.success) {
      const options = response.data.map((data) => ({
        value: data.value,
        label: data.label,
      }));
      setServiceEngineer(options);
    }
  };

  const GetAllProduct = async () => {
    const response = await getData("/masters/allproducts-list");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "product_id",
          label: data.name,
        });
      });
    }
    setProduct(option);
  };

  useEffect(() => {
    GetAllServiceEngineer();
    GetAllProduct();
  }, []);

  const handleProductChange = (selectedOptions) => {
    const updatedProducts = selectedOptions
      ? selectedOptions.map((opt) => {
          const existing = productSelections.find(
            (p) => p.product_id === opt.value
          );

          return existing
            ? existing
            : {
                product_id: opt.value,
                product_name: opt.label,
                quantity: 1,
              };
        })
      : [];

    setProductSelections(updatedProducts);
  };

  const handleQuantityChange = (productId, qty) => {
    const safeQty = Math.max(1, Number(qty));

    setProductSelections((prev) =>
      prev.map((p) =>
        p.product_id === productId ? { ...p, quantity: safeQty } : p
      )
    );
  };

  const handleAssignEngineer = async () => {
    if (!validateForm()) return;

    try {
      setAssignLoading(true);

      const response = await postData(
        `/complaint-management/preventive-maintainance/assign-engineer/${id}`,
        {
          user_id: engineer.value,
          schedule_from: from,
          schedule_time: schedule_time,
          completion_date: completion_date,
          product_id: productSelections,
        }
      );

      if (response.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });

        setTimeout(() => {
          getAllData();
          onHide();
          setEngineer(null);
          setFrom("");
          setErrors({});
          setProductSelections([]);
          setShowModal({ code: 0, message: "" });
        }, 1500);
      } else {
        setTimeout(() => setShowModal({ code: 0, message: "" }), 1500);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAssignLoading(false);
    }
  };

  return (
    <Modal
      className="common_modal Extend_Service_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Assign Engineer</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xl={4} lg={5} md={6} sm={12}>
            <div className="main_div mb-3">
              <Form.Label>Service Engineer</Form.Label>
              <Select
                className={
                  errors.engineer
                    ? "input-mandatory is-invalid"
                    : "input-mandatory"
                }
                value={engineer}
                onChange={(val) => {
                  setEngineer(val);
                  setErrors((prev) => ({ ...prev, engineer: "" }));
                }}
                options={serviceEngineer}
              />
              {errors.engineer && (
                <small className="text-danger">{errors.engineer}</small>
              )}
            </div>
          </Col>
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Schedule Date</Form.Label>
            <input
              type="date"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={from}
              min={new Date().toISOString().split("T")[0]} // ✅ prevents past date selection
              onChange={(e) => {
                setFrom(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.from && (
              <small className="text-danger">{errors.from}</small>
            )}
          </Col>
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Schedule Time</Form.Label>
            <input
              type="time"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={schedule_time}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                setScheduleTime(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.schedule_time && (
              <small className="text-danger">{errors.schedule_time}</small>
            )}
          </Col>{" "}
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Completion Date</Form.Label>
            <input
              type="date"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={completion_date}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                setCompletionDate(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.completion_date && (
              <small className="text-danger">{errors.completion_date}</small>
            )}
          </Col>
        </Row>

        <Row>
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Select Product</Form.Label>

            <Select
              isMulti
              options={product}
              value={product.filter((p) =>
                productSelections?.some((ps) => ps.product_id === p.value)
              )}
              onChange={(selected) => {
                handleProductChange(selected);
                setErrors((prev) => ({ ...prev, product: "" }));
              }}
              className={errors.product ? "is-invalid" : ""}
            />

            {errors.product && (
              <small className="text-danger">{errors.product}</small>
            )}
          </Col>

          {productSelections?.map((item) => {
            const productName = product.find(
              (p) => p.value === item.product_id
            )?.label;

            return (
              <div
                key={item.product_id}
                className="d-flex align-items-center mt-2">
                <span className="me-2" style={{ minWidth: "120px" }}>
                  {productName}
                </span>

                <input
                  type="number"
                  min="1"
                  step="1"
                  className="form-control"
                  style={{ width: "100px" }}
                  value={item.quantity}
                  onChange={(e) => {
                    const value = Math.max(1, Number(e.target.value || 1));
                    handleQuantityChange(item.product_id, value);
                  }}
                  onBlur={(e) => {
                    if (!e.target.value || Number(e.target.value) < 1) {
                      handleQuantityChange(item.product_id, 1);
                    }
                  }}
                />
              </div>
            );
          })}
        </Row>
      </Modal.Body>

      <Modal.Footer>
        {/* <CancelButton name="Cancel" onClick={onHide} /> */}
        <SaveButton
          name={
            assignLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Submitting...
              </>
            ) : (
              "Submit"
            )
          }
          type="submit"
          disabled={assignLoading}
          handleSubmit={handleAssignEngineer}
        />
      </Modal.Footer>

      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </Modal>
  );
};

export default ComplaintAssignEngineer;
